export default "__VITE_ASSET__gxMhv$rz__"